import Head from "next/head";
import React from "react";

import Footer from "../components/Footer";
import Navigation from "../components/Navigation";

import WordpressApi, { Menus } from "../services/wordpressApi";
import ComposerBlocks from "../components/ComposerBlocks";
import Seo from "../components/Seo/Seo";
import { IBreadcrumb } from "../services/breadcrumbReducer";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import { LanguageContextProvider } from "../components/LanguageContext";
import ModalFormsChecker from "../components/ModalFormsChecker/ModalFormsChecker";

export default function Composer({
  data,
  menus,
  tags,
  breadcrumbs = [],
  header,
  htmlHead,
  translatedSlugs,
  lang = "de",
  title,
  link,
}: {
  data: any;
  link: string;
  title: string;
  menus: Menus;
  tags: any;
  breadcrumbs: IBreadcrumb[];
  header: string;
  htmlHead: string;
  translatedSlugs: Record<string, string>;
  lang: string;
}) {
  let courseDescription;
  const isCourse = data.find(
    ({ id }: { id: string }) => id === "lazyblock/courses-available"
  );
  try {
    courseDescription = data.find(
      ({ id }: { id: string }) => id == "lazyblock/what-learn"
    ).attrs.secondText;
  } catch (error) {}
  return (
    <div>
      <Seo header={htmlHead} />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=2.0, minimal-scale=1.0"
        />
        {isCourse ? (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: `{
                  "@context": "https://schema.org/",
                  "@type": "Course",
                  name: "${title}",
                  description:
                    "${courseDescription}",
                  provider: {
                    "@type": "Organization",
                    name: "LCL Institut für Sprachen und Kommunikation",
                    logo: "https://lcl-institut.at/_next/static/images/de-header-logo-8d4c0bbf82cfecdab9a2248a046994fc.svg",
                    url: "${link}",
                  },
                }`,
            }}
          ></script>
        ) : null}
      </Head>
      <LanguageContextProvider lang={lang}>
        <Navigation menu={menus.primary} translatedSlugs={translatedSlugs} />
        <main id="bootstrap-overrides">
          {/* {breadcrumbs && (
            <Breadcrumbs breadcrumbs={breadcrumbs} header={header} />
          )} */}
          <ComposerBlocks data={data} />
          <ModalFormsChecker />
        </main>
        <Footer {...menus} />
      </LanguageContextProvider>
    </div>
  );
}

export async function getServerSideProps({
  resolvedUrl,
  params: { slug },
  ...rest
}: any) {
  let data: any;
  let menus = {};

  try {
    [data, menus] = await Promise.all([
      WordpressApi.getPage(slug[slug.length - 1]),
      WordpressApi.getMenus(),
    ]);
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
  try {
    const urlWP = new URL(data.link);
    if (urlWP.pathname !== resolvedUrl) {
      return {
        redirect: {
          destination: urlWP.pathname,
          permanent: false,
        },
      };
    }
  } catch (error) {
    console.log(error);
    console.log(resolvedUrl);
  }

  if (data.blocks === undefined) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      title: data?.title || "",
      data: data.blocks,
      tags: data.tags,
      breadcrumbs: data?.breadcrumbs,
      htmlHead: data?.htmlHead,
      menus,
      translatedSlugs: data?.translatedSlugs || {},
      link: data?.link || "",
    },
  };
}
